import { downgradeComponent } from '@angular/upgrade/static';
import { run } from '@commons/util/helper/contact';
import { IHttpProvider, module } from 'angular';
import ngI18next from 'ng-i18next';

import { Configuration, Device, LibPhoneConf } from '@contact/upgrade';

import { default as Agent } from '../agent/agent.module.ajs';
import { default as Commons } from '../commons/commons.module.ajs';
import { default as History } from '../history/history.module.ajs';
import { default as Hypervision } from '../hypervision/hypervision.module.ajs';
import { default as Responder } from '../responder/responder.module.ajs';
import { default as Tracking } from '../tracking/tracking.module.ajs';
import { default as WallboardConf } from '../wallboard-conf/wallboard-conf.module.ajs';
import { default as Wallboard } from '../wallboard/wallboard.module.ajs';
import { AppComponent } from './app.component';

/**
 * Initialize AngularJs root module
 */
export function initModuleAjs(params: {
  readonly appConf: Configuration;
  readonly libPhoneConf: LibPhoneConf;
  readonly device: Device;
}): string {
  return module('contactApp', [
    'ngTouch',
    'ui.bootstrap',
    ngI18next,
    Commons,
    Agent,
    History,
    Hypervision,
    Tracking,
    Responder,
    Wallboard,
    WallboardConf,
  ])
    .constant('configuration', params.appConf)
    .constant('libPhoneConfiguration', params.libPhoneConf)
    .constant('device', params.device)
    .config(['$httpProvider', ($httpProvider: IHttpProvider) => ($httpProvider.defaults.withCredentials = true)])
    .directive('cngFrontRoot', downgradeComponent({ component: AppComponent }))
    .run(run).name;
}
